// extracted by mini-css-extract-plugin
module.exports = {"balance":"_077c159","svg":"_c3ae029"};